<template>
	<div class="form-login">
		<form @submit.prevent="onLoginSubmit">
			<div class="form-group" id="input-group-1" label-for="input-1">
				<input
					class="form-control"
					id="username"
					type="email"
					v-model="loginForm.username"
					placeholder="acme@email.com"
				/>
				<p class="error" v-if="$v.loginForm.username.$error">
					Please enter your email
				</p>
				<input
					class="form-control"
					id="password"
					type="password"
					v-model="loginForm.password"
					placeholder="********"
				/>
				<p class="error" v-if="$v.loginForm.password.$error">
					Please enter your password
				</p>
			</div>
			<button
				type="submit"
				variant="primary"
				:class="['btn btn-primary', { disabled: lock === true }]"
			>
				Login
				<div class="spinner-border spinner-border-sm" v-if="lock"></div>
			</button>
			<div class="form-error" v-if="errorMessage">
				{{ errorMessage }}
			</div>
			<br />
			<br />
			<!-- <p>
				Forgot your password?
				<a href="#" @click="tabIndex = 2">Reset password.</a>
			</p> -->
			<!-- <p>
				Don't have an account? Install the
				<a
					href="https://chrome.google.com/webstore/detail/underlineme-highlighter-f/bfgkgjjcgcfdjdcdcicnekhhldinkkhk"
					target="_blank"
					>extension.</a
				>
				<a href="#" @click="tabIndex++">Signup</a> for a free trial.
			</p> -->
		</form>
	</div>
</template>

<script>
import { required, minLength, between } from 'vuelidate/lib/validators';
import emailValidator from '@/lib/email-validator.js';
export default {
	data: function () {
		return {
			lock: false,
			errorMessage: '',
			loginForm: {
				username: '',
				password: '',
			},
		};
	},
	validations: {
		loginForm: {
			username: {
				required,
				minLength: minLength(3),
			},
			password: {
				required,
				minLength: minLength(3),
			},
		},
	},
	methods: {
		onLoginSubmit: function () {
			this.$v.$touch();
			if (!this.$v.loginForm.$invalid) {
				this.submitLogin();
			}
		},
		async submitLogin() {
			this.lock = true;
			console.log('submitting login');
			let response = await this.$store.dispatch('user/login', this.loginForm);
			if (response) {
				await this.$store.dispatch('block/notesToBlocks');
				this.$emit('success');
			} else {
				this.errorMessage = 'Login details seem incorrect, please try again';
			}
			this.reset();
			this.lock = false;
			// .then((res) => {
			// 	if (res) {
			// 		this.$bvModal.hide('modal-intro');
			// 		this.errorMessage = '';
			// 		this.lock = false;
			// 	} else {
			// 		this.errorMessage =
			// 			'No user with that email and password combination exists. Please enter re-enter your details';
			// 		this.lock = false;
			// 	}
			// })
			// .catch((err) => {
			// 	this.errorMessage =
			// 		'No user with that email and password combination exists. Please enter re-enter your details';
			// 	this.lock = false;
			// });
		},
		reset: function () {
			this.loginForm = {
				username: '',
				password: '',
			};
		},
	},
};
</script>

<style lang="scss">
.form-login {
	.custom-radio {
		background-color: rgba(0, 0, 0, 0.15);
		padding: 0.5rem;
		padding-left: 36px;
		border-radius: 8px;
		margin-bottom: 1rem;
	}
	.custom-control-label {
		width: 100%;
		h4 {
			margin-bottom: 0.2rem;
		}
		&:before {
			left: -26px;
		}
		&:after {
			left: -26px;
		}
		p {
			margin: 0;
		}
	}

	.spinner-border {
		margin-left: var(--margin-sm);
	}
}
</style>
